import { CASE_REPO } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: CASE_REPO,
  params: {},
  needFetchFillInfo: false,
  view: {
    title: '创建共享用例',
    labelPosition: 'right',
    labelWidth: '170px',
    width: '700px',
    content: [
      {
        $id: 'testCaseName',
        $type: 'input',
        label: 'testcaseMng.testCaseName',
        $el: {
          placeholder: '请输入用例名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseName'
          }
        ]
      },
      {
        $id: 'testCaseType',
        $type: 'radio-group',
        label: 'testcaseMng.testCaseType',
        $el: {},
        $options: [
          {
            label: '功能用例',
            value: 'BUSINESS'
          },
          {
            label: '外设用例',
            value: 'PERIPHERAL'
          },
          {
            label: '软件用例',
            value: 'SOFTWARE'
          }
        ],
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseType'
          }
        ]
      },
      {
        $id: 'testCaseContent',
        $type: 'input',
        $el: {
          placeholder: '请输入用例内容',
          type: 'textarea',
          rows: 5
        },
        label: 'testcaseMng.testCaseContent',
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseContent'
          }
        ]
      },
      {
        $id: 'testCaseScene',
        $type: 'input',
        label: 'testcaseMng.testCaseScene',
        $el: {
          placeholder: '请输入用例场景',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      },
      {
        $id: 'userDemand',
        $type: 'input',
        label: 'testcaseMng.testUserDemand',
        $el: {
          placeholder: '请输入用户诉求',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        }
      },
      {
        $id: 'testCaseStep',
        $type: 'input',
        label: 'testcaseMng.testCaseStep',
        $el: {
          placeholder: '请输入用户步骤',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        }
      },
      {
        $id: 'testCaseExpectedResult',
        $type: 'input',
        label: 'testcaseMng.testCaseExpectedResult',
        $el: {
          placeholder: '请输入预期结果',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      },
      {
        $id: 'remarks',
        $type: 'input',
        label: 'testcaseMng.remarks',
        tip: {
          description: ['testcaseMng.tips.remarks']
        },
        $el: {
          placeholder: '请输入备注',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      },
      {
        $id: 'compatibleDTOList',
        $type: 'sky-product-os-relate',
        label: '支持的产品及操作系统',
        $default: null,
        rules: [
          {
            // notEmpty: '支持的产品及操作系统'
          }
        ]
      }
    ]
  }
}
